export default __webpack_public_path__ + "static/media/typeBus.18f037a7.18f037a7.svg";